<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>

    <el-row class="ml-20 mr-20" v-if="!editMode">
      <el-col :xs="12" :sm="12" :lg="12">
        <!-- <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button> -->
        <div>&nbsp;</div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" >
        <el-button type="primary" @click.prevent="createTodo" style="float: right;" size="mini">新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
      </el-col>
    </el-row>
  
    <el-row>
      <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
          <el-table-column prop="title" label="標題" >
              <template slot-scope="scope">
                <router-link :to="`${scope.row.todoUrl}${scope.row.id}`">{{scope.row.title }}
                </router-link>
                <p>{{scope.row.reqPayNo}}</p>
              </template>
          </el-table-column>
          
          <el-table-column label="狀態" >
            <template slot-scope="scope">
              <el-tag :type="caseType(scope.row.status)">{{ scope.row.status | fmtSignResult}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-popconfirm
                  class="ml-10 popconfirm-bg"
                  title="確定刪除此筆資料嗎?"
                  confirm-button-text="確定"
                  cancel-button-text="取消刪除"
                  icon="el-iconf-info"
                  icon-color="red"
                  @confirm="handleDelete(scope.row.id)"
              >
              <el-button v-if="scope.row.status === 'draft'" type="danger" icon="el-icon-delete" circle slot="reference"></el-button>
                
              </el-popconfirm>
            </template>
          </el-table-column>
          
        </el-table>

        <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
          <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </el-main>
    </el-col>

    </el-row>


    <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

       
        <el-button type="primary" @click.prevent="search" size="mini" class="ml-10 mt-10">查詢</el-button>
        <el-button type="normal" @click.prevent="clearQuery" size="mini" class="ml-10 mt-10">清除條件</el-button>
    </el-drawer>

  </div>
</template>

<script>

import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import request from "@/api/request";

export default {
  name: 'ReqMilesMaintain',
  components:{
    Breadcrumb
  },
  data(){
    return {
      pageNum:0,
      pageSize:20,
      total:0,
      tableData:[],

      editMode: false,
      drawer:false,
      direction: 'ltr',
      dw: '60%',
      startDate:'',
      endDate:'',
      form:{
        submitBy: this.$store.state.login.userInfo.id,
        title:'',
        startDate: '',
        endDate: '',
        status: 'draft',
        todoType: 'req_miles',
        hasMile:'Y'
      }
    }
  },
  methods:{
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    loadData(){
      let {pageNum, pageSize, startDate, endDate} = this

      let url = "/req-miles/my?pageNum=" + pageNum + "&pageSize=" + pageSize + "&startDate=" + startDate + "&endDate=" + endDate
      this.request.get(url).then(res => {
          if (res.code === '200') {
            this.tableData = res.data.records
            this.total = res.data.total
          } else {
            this.showResult('error', "資料取得失敗")
          }
        })
    },
    createTodo(){
      this.form.title = "哩程補貼申請單"
      this.form.startDate = new Date()
      console.log(this.form)
      this.request.post("/todo", this.form).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    },
    handleDelete(id) {
      this.request.delete("/todo/" + id).then(res => {
        if (res.code === '200') {
          this.loadData();
          this.showResult("success", "資料刪除成功")
        } else {
          this.showResult("error", "資料刪除失敗")
        }
      })
    },

    caseType(status) {
      if (status === '草稿') return ''
      if (status === '簽核中') return 'warning'
      if (status === '退回') return 'danger'
      if (status === '完成') return 'success'
      if (status === 'invalid') return 'danger'
    },

    //查詢 drawer
    handleClose(){
      this.drawer = false
    },
    search(){
      this.drawer = false
      this.loadData()
    },
    clearQuery(){
      this.form.startDate = ''
      this.form.endDate = ''
      this.loadData()
    },
    setDialogWidth(){
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = '60%'
      }
    }

  },
  mounted(){
    this.loadData()
    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
  }
}

</script>

<style scoped>
  
</style>